import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";

/**
 * Wrapper for the accordion component.
 */
export const Wrapper = styled("div")({
  display: "flex",
  width: "100%"
});

/**
 * Icon wrapper for clickable icons.
 */
export const IconWrapper = styled("div")({
  margin: "10px 0px 10px 10px",
  cursor: "pointer"
});

/**
 * AccordionDiv styled for custom color and transitions.
 */
export const AccordionDiv = styled("div")(({ customStyle }) => ({
  color: customStyle === "special" ? "#444" : "#000",
  cursor: "pointer",
  width: "100%",
  border: "none",
  outline: "none",
  transition: "0.4s"
}));

/**
 * Panel for collapsible content.
 */
export const Panel = styled("div")({
  padding: "0 18px",
  maxHeight: "0",
  overflow: "hidden",
  transition: "max-height 0.25s ease-out"
});

/**
 * PlainAccordion removes box-shadow and hides the first child.
 */
export const PlainAccordion = styled("div")({
  "& > div:first-of-type": {
    boxShadow: "none",
    "& > div:first-of-type": {
      display: "none"
    }
  }
});

/**
 * DoneIcon styled SVG.
 */
export const DoneIcon = styled("svg")({
  width: "24px",
  height: "22px",
  fill: "#39C4A5",
  margin: "auto"
});

/**
 * Header container for accordion summary.
 */
export const HeaderContainer = styled("div")({
  display: "inline-flex",
  flexDirection: "row",
  width: "100%"
});

/**
 * Root container for the accordion.
 */
export const Root = styled("div")({
  backgroundColor: "#eee",
  borderRadius: 5,
  marginBottom: "50px !important"
});

/**
 * SummaryRoot for the accordion summary border.
 */
export const SummaryRoot = styled("div")({
  borderBottom: "1px solid #dddddd"
});

/**
 * Icon container for summary icons.
 */
export const IconContainer = styled("div")({
  display: "flex"
});

/**
 * StyledAccordion using MUI v5 styled API.
 */
export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: "#eee",
  borderRadius: 5,
  marginBottom: "50px !important",
  marginTop: "15px"
}));

/**
 * StyledAccordionSummary using MUI v5 styled API.
 */
export const StyledAccordionSummary = styled(AccordionSummary)({
  borderBottom: "1px solid #dddddd"
});
